<template>
  <div class="activity__item-options">
    <span class="activity__item-edit" data-option="edit" @click="editionRequested">
      {{ $t('card_modal.ui.activity_edit') }}
    </span>
    -
    <Popper :title="$t('card_modal.ui.activity_delete_warn_title')" placement="top-start">
      <template #popper-trigger>
        <span class="activity__item-delete">
          {{ $t('card_modal.ui.activity_delete') }}
        </span>
      </template>
      <template #popper-content>
        <span>
          {{ $t('card_modal.ui.activity_delete_warn') }}
        </span>
      </template>
      <!-- delete action -->
      <template #popper-action="{ closePopper }">
        <AppActionButton data-option="delete" @click="editionRequested($event), closePopper()">
          {{ $t('card_modal.ui.activity_delete') }}
        </AppActionButton>
      </template>
    </Popper>
  </div>
</template>

<script>
// Utilities
import Popper from 'Modules/Popper'
import AppActionButton from 'Ui/AppActionButton'

export default {
  name: 'CardModalActivityItemOptions',

  components: {
    Popper,
    AppActionButton,
  },

  methods: {
    editionRequested(event) {
      const action = event.target.dataset.option
      this.$emit('option-requested', action)
    },
  },
}
</script>

<style scoped>
.activity__item-options {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-left: 2px;
}

.activity__item-options .activity__item-edit,
.activity__item-options .activity__item-delete {
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}

.activity__item-options .activity__item-edit:hover,
.activity__item-options .activity__item-delete:hover {
  color: var(--c-secondary-700);
  text-decoration: none;
}

.app-action-button {
  width: 100%;
  max-width: 100%;
  margin-top: 20px;
}
</style>
